import TripOverview from './TripOverview';
import './TripOverview.scss';

export default TripOverview;
